module.exports = __webpack_public_path__ + "img/pic_banner.4a017d14.png";